import { useEffect, useState, useMemo } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import { APP_ROUTES } from "../../config/appRoutes";
import { useData } from "../../context/DataContext";
import HistoryIcon from "@mui/icons-material/History";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

const TAB_ROUTES = {
    0: APP_ROUTES.EMPLOYEE.HISTORY,
    1: APP_ROUTES.EMPLOYEE.CREATION,
};

function Employee() {
    const navigate = useNavigate();
    const location = useLocation();
    const { employees = [], user = {}, userLevels = [] } = useData();

    const [tab, setTab] = useState(0);

    // Handle tab change
    const handleTabChange = (_, newValue) => {
        setTab(newValue);
        navigate(TAB_ROUTES[newValue]);
    };

    // Sync tab with URL
    useEffect(() => {
        if (location.pathname.includes(APP_ROUTES.EMPLOYEE.CREATION)) {
            setTab(1);
        } else {
            setTab(0);
        }
    }, [location.pathname]);


    const employeesData = useMemo(() => {
        return employees?.filter(employee => employee.level_id > user.user_level_id).map(employee => {
            const userLevel = userLevels.find(level => level.value === employee.level_id);
            return {
                ...employee,
                user_level_name: userLevel ? userLevel.label : null,
            };
        });
    }, [employees, user.user_level_id, userLevels]);


    useEffect(() => {
        if (tab === 0) {
            navigate(APP_ROUTES.EMPLOYEE.HISTORY, { state: { employeesData } });
        } else if (tab === 1) {
            navigate(APP_ROUTES.EMPLOYEE.CREATION, { state: { user, employeesData } });
        }
    }, [tab, navigate, employeesData, user]);

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
                <Tabs value={tab} onChange={handleTabChange} TabIndicatorProps={{
                    style: {
                        backgroundColor: "#2e7d32", // green
                    },
                }}>
                    <Tab label="Employee Details" icon={<HistoryIcon />} iconPosition="start" sx={{
                        color: "success.main",
                        "&.Mui-selected": {
                            color: "success.main",
                        },
                    }} />
                    {user.user_level_id !== 4 && (
                        <Tab label="Create Employee" icon={<AddCircleOutlineIcon />} iconPosition="start" sx={{
                            color: "success.main",
                            "&.Mui-selected": {
                                color: "success.main",
                            },
                        }} />
                    )}
                </Tabs>
            </Box>

            <Outlet />
        </>
    );
}

export default Employee;
